import * as React from "react";
import type { SVGProps } from "react";
const SvgCompass = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m3.584 21.6 7.364-12.888m2.63 0L20.416 21.6M4.363 14.762c1.928 2.902 4.753 4.734 7.9 4.734s5.973-1.832 7.9-4.734m-7.9-11.047a2.63 2.63 0 1 0 0 5.26 2.63 2.63 0 0 0 0-5.26m0 0V2.4"
    />
  </svg>
);
export default SvgCompass;
